/** Yonsei–Yale isochrones (B−V vs Mv) extracted from legacy Midas ISO.csv — solar Z, [Fe/H]=0. */

export interface IsoPoint { mv: number; bv: number; }

export interface AgeIsochrone {
  ageGyr: number;
  label: string;
  shortLabel: string;
  note: string;
  points: IsoPoint[];
}

const RAW: Record<string, IsoPoint[]> = {
  '0.080': [
    { mv: 12.827, bv: 1.932 },
    { mv: 10.148, bv: 1.512 },
    { mv: 8.208, bv: 1.23 },
    { mv: 7.411, bv: 1.105 },
    { mv: 6.637, bv: 0.979 },
    { mv: 5.92, bv: 0.848 },
    { mv: 5.289, bv: 0.718 },
    { mv: 4.733, bv: 0.603 },
    { mv: 4.26, bv: 0.518 },
    { mv: 3.817, bv: 0.444 },
    { mv: 3.423, bv: 0.385 },
    { mv: 3.071, bv: 0.328 },
    { mv: 2.755, bv: 0.266 },
    { mv: 2.474, bv: 0.205 },
    { mv: 2.227, bv: 0.15 },
    { mv: 2.015, bv: 0.102 },
    { mv: 1.834, bv: 0.061 },
    { mv: 1.672, bv: 0.027 },
    { mv: 1.526, bv: -0.002 },
    { mv: 1.39, bv: -0.024 },
    { mv: 1.26, bv: -0.042 },
  ],
  '0.100': [
    { mv: 12.891, bv: 1.921 },
    { mv: 10.32, bv: 1.519 },
    { mv: 9.221, bv: 1.381 },
    { mv: 7.375, bv: 1.1 },
    { mv: 6.528, bv: 0.961 },
    { mv: 5.018, bv: 0.668 },
    { mv: 4.337, bv: 0.536 },
    { mv: 4.097, bv: 0.494 },
    { mv: 3.975, bv: 0.474 },
    { mv: 3.736, bv: 0.436 },
    { mv: 3.62, bv: 0.418 },
    { mv: 3.393, bv: 0.383 },
    { mv: 3.29, bv: 0.366 },
    { mv: 3.086, bv: 0.331 },
    { mv: 2.996, bv: 0.314 },
    { mv: 2.821, bv: 0.28 },
    { mv: 2.736, bv: 0.263 },
    { mv: 2.577, bv: 0.229 },
    { mv: 2.498, bv: 0.212 },
    { mv: 2.343, bv: 0.178 },
    { mv: 2.268, bv: 0.162 },
    { mv: 2.122, bv: 0.129 },
    { mv: 2.05, bv: 0.113 },
    { mv: 1.913, bv: 0.083 },
    { mv: 1.847, bv: 0.068 },
    { mv: 1.718, bv: 0.041 },
    { mv: 1.656, bv: 0.028 },
    { mv: 1.533, bv: 0.004 },
    { mv: 1.472, bv: -0.006 },
    { mv: 1.35, bv: -0.025 },
    { mv: 1.289, bv: -0.033 },
    { mv: 1.167, bv: -0.048 },
  ],
  '0.200': [
    { mv: 12.554, bv: 1.802 },
    { mv: 10.389, bv: 1.495 },
    { mv: 8.491, bv: 1.266 },
    { mv: 6.92, bv: 1.032 },
    { mv: 5.56, bv: 0.778 },
    { mv: 4.843, bv: 0.627 },
    { mv: 4.736, bv: 0.605 },
    { mv: 4.52, bv: 0.565 },
    { mv: 4.307, bv: 0.527 },
    { mv: 4.094, bv: 0.49 },
    { mv: 3.882, bv: 0.456 },
    { mv: 3.674, bv: 0.424 },
    { mv: 3.468, bv: 0.394 },
    { mv: 3.278, bv: 0.364 },
    { mv: 3.094, bv: 0.335 },
    { mv: 2.931, bv: 0.306 },
    { mv: 2.854, bv: 0.291 },
    { mv: 2.703, bv: 0.262 },
    { mv: 2.561, bv: 0.232 },
    { mv: 2.418, bv: 0.203 },
    { mv: 2.278, bv: 0.174 },
    { mv: 2.141, bv: 0.146 },
    { mv: 2.008, bv: 0.118 },
    { mv: 1.877, bv: 0.092 },
    { mv: 1.751, bv: 0.067 },
    { mv: 1.627, bv: 0.044 },
    { mv: 1.566, bv: 0.033 },
    { mv: 1.446, bv: 0.012 },
    { mv: 1.324, bv: -0.006 },
    { mv: 1.202, bv: -0.022 },
    { mv: 1.077, bv: -0.037 },
    { mv: 0.947, bv: -0.049 },
  ],
  '0.400': [
    { mv: 12.662, bv: 1.806 },
    { mv: 10.715, bv: 1.541 },
    { mv: 8.987, bv: 1.342 },
    { mv: 6.899, bv: 1.031 },
    { mv: 5.707, bv: 0.81 },
    { mv: 5.509, bv: 0.768 },
    { mv: 5.315, bv: 0.727 },
    { mv: 5.122, bv: 0.687 },
    { mv: 4.837, bv: 0.627 },
    { mv: 4.648, bv: 0.59 },
    { mv: 4.458, bv: 0.556 },
    { mv: 4.272, bv: 0.523 },
    { mv: 4.085, bv: 0.491 },
    { mv: 3.807, bv: 0.447 },
    { mv: 3.625, bv: 0.42 },
    { mv: 3.444, bv: 0.394 },
    { mv: 3.272, bv: 0.369 },
    { mv: 3.109, bv: 0.344 },
    { mv: 2.953, bv: 0.319 },
    { mv: 2.742, bv: 0.281 },
    { mv: 2.606, bv: 0.256 },
    { mv: 2.472, bv: 0.231 },
    { mv: 2.338, bv: 0.206 },
    { mv: 2.203, bv: 0.182 },
    { mv: 2.0, bv: 0.146 },
    { mv: 1.867, bv: 0.123 },
    { mv: 1.731, bv: 0.101 },
    { mv: 1.596, bv: 0.081 },
    { mv: 1.459, bv: 0.061 },
    { mv: 1.246, bv: 0.034 },
    { mv: 1.095, bv: 0.018 },
    { mv: 0.93, bv: 0.004 },
  ],
  '0.600': [
    { mv: 12.798, bv: 1.829 },
    { mv: 10.126, bv: 1.474 },
    { mv: 8.622, bv: 1.293 },
    { mv: 6.746, bv: 1.006 },
    { mv: 5.995, bv: 0.869 },
    { mv: 5.804, bv: 0.831 },
    { mv: 5.53, bv: 0.774 },
    { mv: 5.263, bv: 0.717 },
    { mv: 5.086, bv: 0.68 },
    { mv: 4.823, bv: 0.626 },
    { mv: 4.561, bv: 0.576 },
    { mv: 4.386, bv: 0.546 },
    { mv: 4.128, bv: 0.501 },
    { mv: 3.872, bv: 0.459 },
    { mv: 3.701, bv: 0.434 },
    { mv: 3.448, bv: 0.398 },
    { mv: 3.207, bv: 0.364 },
    { mv: 2.972, bv: 0.331 },
    { mv: 2.835, bv: 0.308 },
    { mv: 2.627, bv: 0.275 },
    { mv: 2.429, bv: 0.242 },
    { mv: 2.293, bv: 0.22 },
    { mv: 2.083, bv: 0.189 },
    { mv: 1.866, bv: 0.158 },
    { mv: 1.716, bv: 0.139 },
    { mv: 1.472, bv: 0.111 },
    { mv: 1.189, bv: 0.088 },
    { mv: 0.937, bv: 0.078 },
    { mv: 0.619, bv: 0.084 },
    { mv: 0.41, bv: 0.106 },
    { mv: 0.307, bv: 0.127 },
    { mv: 0.174, bv: 0.163 },
  ],
  '1.000': [
    { mv: 12.893, bv: 1.848 },
    { mv: 10.443, bv: 1.512 },
    { mv: 8.495, bv: 1.275 },
    { mv: 6.941, bv: 1.04 },
    { mv: 6.769, bv: 1.011 },
    { mv: 6.513, bv: 0.966 },
    { mv: 6.265, bv: 0.921 },
    { mv: 6.018, bv: 0.875 },
    { mv: 5.778, bv: 0.827 },
    { mv: 5.547, bv: 0.779 },
    { mv: 5.395, bv: 0.747 },
    { mv: 5.171, bv: 0.7 },
    { mv: 4.943, bv: 0.653 },
    { mv: 4.72, bv: 0.608 },
    { mv: 4.492, bv: 0.568 },
    { mv: 4.262, bv: 0.529 },
    { mv: 4.11, bv: 0.504 },
    { mv: 3.885, bv: 0.468 },
    { mv: 3.659, bv: 0.435 },
    { mv: 3.429, bv: 0.405 },
    { mv: 3.198, bv: 0.377 },
    { mv: 2.974, bv: 0.349 },
    { mv: 2.829, bv: 0.331 },
    { mv: 2.612, bv: 0.304 },
    { mv: 2.387, bv: 0.279 },
    { mv: 2.138, bv: 0.256 },
    { mv: 1.849, bv: 0.236 },
    { mv: 1.51, bv: 0.234 },
    { mv: 1.367, bv: 0.245 },
    { mv: 1.216, bv: 0.272 },
    { mv: 1.11, bv: 0.306 },
    { mv: 1.001, bv: 0.339 },
  ],
};

const META: Record<string, { label: string; short: string; note: string }> = {
  '0.080': { label: '80 Myr', short: '80 Myr', note: 'Very young — turnoff above Mv ≈ 1.3' },
  '0.100': { label: '100 Myr', short: '100 Myr', note: 'Pleiades age — high turnoff, narrow MS gap' },
  '0.200': { label: '200 Myr', short: '200 Myr', note: 'M34 best fit — turnoff near Mv ≈ 1' },
  '0.400': { label: '400 Myr', short: '400 Myr', note: 'Hyades-like — turnoff fainter, gap widens' },
  '0.600': { label: '600 Myr', short: '600 Myr', note: 'Mature cluster — only low-mass stars on MS' },
  '1.000': { label: '1 Gyr', short: '1 Gyr', note: 'Old open cluster — turnoff near solar mass' },
};

export const ISOCHRONE_AGES: AgeIsochrone[] = Object.entries(RAW)
  .map(([k, points]) => ({
    ageGyr: parseFloat(k),
    label: META[k].label,
    shortLabel: META[k].short,
    note: META[k].note,
    points,
  }))
  .sort((a, b) => a.ageGyr - b.ageGyr);

/** Ages highlighted in the scrolly age-compare step */
export const SCROLLY_COMPARE_AGES = ISOCHRONE_AGES.filter((a) =>
  [0.1, 0.2, 0.4, 0.6].includes(a.ageGyr),
);

export const M34_AGE_GYR = 0.2;

export function turnoffPoint(iso: IsoPoint[]): IsoPoint {
  return iso.reduce((best, p) => (p.mv < best.mv ? p : best), iso[0]);
}
